module.exports = __webpack_public_path__ + "img/595.512787d8.jpg";